var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvestmentsEtfAndFunds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-5026.000000, -904.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Investments/ETF-and-funds",
    transform: "translate(5026.000000, 904.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.773,21.337 L13.634,15.198 C14.482,14.351 15.856,14.351 16.704,15.198 L18.688,17.183 L18.688,11.292 L20.859,11.292 L20.858,17.182 L22.842,15.198 C23.69,14.351 25.064,14.351 25.912,15.198 L19.773,21.337 Z M15.021,23.014 L13.037,21.029 L13.038,26.92 L10.867,26.92 L10.867,21.029 L8.882,23.014 C8.035,23.861 6.661,23.861 5.813,23.014 L11.952,16.875 L18.09,23.014 C17.243,23.861 15.869,23.861 15.021,23.014 L15.021,23.014 Z M28,7 L14,7 L10,2 L0,2 L0,27 C0,29.209 1.791,31 4,31 L32,31 L32,11 C32,8.791 30.209,7 28,7 L28,7 Z",
    id: 23
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentsEtfAndFunds);
export default __webpack_public_path__ + "static/media/investments-etf-and-funds.003fa568.svg";
export { ForwardRef as ReactComponent };